import React, { memo } from "react";
import "./ColumnFooter.css";

interface Props {
    color: string;
}

const ColumnFooter: React.FC<Props> = function ({ color }: Props) {
    return <div className="column_footer" style={{ backgroundColor: color }} />;
}

export default memo(ColumnFooter);
